import { FunctionComponent } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useTranslation } from '@/lib';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonClassName?: string;
}

export const ConfirmationDialog: FunctionComponent<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  confirmButtonClassName = 'bg-red-600 hover:bg-red-700 dark:bg-red-400 dark:hover:bg-red-500',
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title || t('confirm')}</DialogTitle>
      <DialogContent>{message || t('are_you_sure')}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          {cancelText || t('cancel')}
        </Button>
        <Button onClick={onConfirm} variant="contained" className={confirmButtonClassName}>
          {confirmText || t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
